import { render, staticRenderFns } from "./VodaDialog.vue?vue&type=template&id=3411b9bb"
import script from "./VodaDialog.vue?vue&type=script&lang=js"
export * from "./VodaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports